
    <h1 mat-dialog-title class="text-center mb-4 text-danger">Warning: Percentage is too high</h1>
    <div class="d-flex flex-column align-items-center">
      <p class="text-center mb-4">
        ES Requires less than 4% LTO. ES Requires less than 8% Total (12% with 3 or more returns)
      </p>
      <button mat-button color="primary" (click)="dialogRef.close()">OK</button>
    </div>
  